export const Y_AXIS_MAX_DECIMALS = 1;

export type GetYAxisDataOptions = {
  startValue?: number;
  endValue?: number;
  // caps only the top of the domain; the bottom keeps using endValue
  maxEndValue?: number;
};

export type YAxisData = {
  domain: [number, number];
  ticks: [number, number, number];
};

export const getYAxisData = (
  entries: { value?: number | null }[],
  { startValue = 0, endValue, maxEndValue }: GetYAxisDataOptions,
): YAxisData => {
  const entryValues = entries
    .map(({ value }) => value)
    .filter(Boolean) as number[];
  const endVal = endValue ?? startValue + 1;
  const minValue = Math.min(...entryValues, startValue, endVal);
  const rawMaxValue = Math.max(
    ...entryValues,
    startValue,
    maxEndValue ?? endVal,
  );
  // a flat dataset still needs a non-degenerate domain to render
  const maxValue = rawMaxValue === minValue ? minValue + 1 : rawMaxValue;
  const domain: [number, number] = [minValue, maxValue];

  return {
    domain,
    ticks: [domain[0], domain[0] + (domain[1] - domain[0]) / 2, domain[1]],
  };
};
